export const APP_HEADER_COMPONENT = 'MFE:AppHeader';
